if (!customElements.get('ares-about-split-slider')) {
  class AresAboutSplitSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ares-about-split__slide'));
      this.dots = Array.from(this.querySelectorAll('.ares-about-split__dot'));

      if (this.slides.length < 2) return;

      this.current = 0;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.speed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.goTo(index);
          this.resetAutoplay();
        });
      });

      if (this.autoplayEnabled && !this.reducedMotion.matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
        this.addEventListener('focusin', this.stopAutoplay.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.reducedMotion.addEventListener('change', this.onReducedMotionChange.bind(this));
      }
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    onReducedMotionChange() {
      if (this.reducedMotion.matches) {
        this.stopAutoplay();
      } else if (this.autoplayEnabled) {
        this.startAutoplay();
      }
    }

    onFocusOut(event) {
      if (!this.contains(event.relatedTarget)) {
        this.startAutoplay();
      }
    }

    goTo(index) {
      if (index === this.current || index < 0 || index >= this.slides.length) return;

      this.slides[this.current].classList.remove('is-active');
      this.dots[this.current]?.classList.remove('is-active');
      this.dots[this.current]?.setAttribute('aria-selected', 'false');

      this.current = index;

      this.slides[this.current].classList.add('is-active');
      this.dots[this.current]?.classList.add('is-active');
      this.dots[this.current]?.setAttribute('aria-selected', 'true');
    }

    next() {
      this.goTo((this.current + 1) % this.slides.length);
    }

    startAutoplay() {
      if (!this.autoplayEnabled || this.reducedMotion.matches) return;
      this.stopAutoplay();
      this.timer = window.setInterval(() => this.next(), this.speed);
    }

    stopAutoplay() {
      window.clearInterval(this.timer);
    }

    resetAutoplay() {
      if (!this.autoplayEnabled || this.reducedMotion.matches) return;
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  customElements.define('ares-about-split-slider', AresAboutSplitSlider);
}
